import { createFileRoute } from "@tanstack/react-router";
import { Paper } from "@mui/material";
import HgBreadcrumbs from "@/common/components/ui/atoms/HgBreadcrumbs";
import AdminPendingRequests from "@/common/components/views/AdminPendingRequests";
import { usePendingPermissions } from "@/pages/admin/pending";

export const Route = createFileRoute("/app/admin/pending/requests")({
  component: RouteComponent,
});

function RouteComponent() {
  const { userCanEditAllRequests, userCanViewAllRequests, userCanViewAllUsers } = usePendingPermissions();

  return (
    <>
      <HgBreadcrumbs
        options={[
          { title: "Admin", link: null, unlink: true },
          { title: "Pending Requests", link: null },
        ]}
      />
      <h1>Pending Requests</h1>
      <Paper sx={{ p: 0 }}>
        <AdminPendingRequests
          userCanEditAllRequests={userCanEditAllRequests}
          userCanViewAllRequests={userCanViewAllRequests}
          userCanViewAllUsers={userCanViewAllUsers}
        />
      </Paper>
    </>
  );
}
